import { tabsApiConnector } from 'apiConnector/tabs/tabs';
import type { AddonPersistedTabContent } from 'apiConnector/tabs/tabs.model';
import { ofType } from 'redux-observable';
import type { Observable, SchedulerLike } from 'rxjs';
import { of } from 'rxjs';
import { catchError, filter, map, mergeMap, skipUntil, timeoutWith } from 'rxjs/operators';
import { addonFormRequested } from 'state/addonForm/addonForm.action';
import type { EpicWithThunk } from 'state/state.common';
import { workspaceTabContentFetchFailed } from 'state/workspaces/tabContent/tabContent.actions';

export function fetchAddonFormWhenWorkspaceAlreadyInitializedEpic(
  timeoutInMillis: number = 60000,
  appScheduler?: SchedulerLike,
): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const createdTab$ = actions$.pipe(
      ofType('WORKSPACE_TAB_CREATED'),
      filter(action => action.workspace === 'postTrade'),
      filter(action => action.tabType === 'addOn'),
      map(a => a.id),
    );

    const alreadyInitializedWorkspace$ = actions$.pipe(
      ofType('WORKSPACE_TABS_FETCH_REQUESTED'),
      filter(action => action.workspace === 'postTrade'),
    );

    // If we create a new addon tab and workspace has already been initialized
    // then we request the addon form
    // If we create a new addon tab and workspace has not been initialized
    // then see the tabContentEpic
    return createdTab$.pipe(
      skipUntil(alreadyInitializedWorkspace$),
      mergeMap(tabId =>
        (tabsApiConnector(httpClient, 'postTrade').getTabContent(tabId) as Observable<AddonPersistedTabContent>).pipe(
          map(({ productId, rfqId }) => addonFormRequested(tabId, productId, rfqId)),
          catchError(error => of(workspaceTabContentFetchFailed(tabId, 'postTrade', error.message))),
          timeoutWith(timeoutInMillis, of(workspaceTabContentFetchFailed(tabId, 'postTrade', 'Timeout')), appScheduler),
        ),
      ),
    );
  };
}
